module.exports = __webpack_public_path__ + "static/media/ee.71870cee.png";